module.exports = __webpack_public_path__ + "img/thailand.945175e1.svg";